const level = [
  [  0,   0,   0,   0,   0,   0,   0,   0,   0,   0],
  [ 0,   0,    0,   0,   0,   0,   0,   0,   0,   0],
  [ 99,  99,  99,  99,  99,  99,  99,  99,   0,   0],
  [ 99,  52,   0,   7,   0,   0,  38,  99,  99,   0],
  [ 99,   0,  10,  99,   9,  77,  99,  64,  99,   0],
  [ 99,   0,   0,   8,   0,   0,  51,   0,  99,   0],
  [ 99,  99,   0,   0,   0,   0,   0,   0,  99,   0],
  [  0,  99,  99,  99,  99,  99,  99,  99,  99,   0],
  
]

export default level